.action-group {
  min-height: 32px;
  padding-inline: 48px;
  background-color: #e8e8e9;
}

.action-group::part(more-actions-list),
.action-group-item::part(list),
.dropdown::part(list),
.dropdown-item::part(list) {
  width: max-content;
  padding-block: 4px;
  background-color: #fff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
  line-height: 24px;
}

.action-group-item::part(action) {
  padding-inline: 8px;
}

.action-group-item::part(action):hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.dropdown-item::part(action) {
  padding-block: 2px;
  padding-inline: 32px;
  gap: 6px;
}

.dropdown-item::part(action):hover {
  background-color: #0060c0;
  color: white;
}

.dropdown-item::part(start-img) {
  width: 18px;
  height: 18px;
  min-width: 18px;
  margin-inline-start: -24px;
  padding: 1px;
}

.dropdown-item::part(shortcut) {
  margin-inline-start: 128px;
}

.dropdown-item::part(expandable-action)::after {
  content: "";
  display: flex;
  block-size: 0;
  inline-size: 0;
  position: absolute;
  inset-inline-end: 14px;
  border-block: 5px solid transparent;
  border-inline-start: 7px solid currentColor;
}

ch-grid::part(main)::-webkit-scrollbar {
  width: 12px;
  background-color: red;
}

ch-grid::part(main)::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

ch-grid::part(main)::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

ch-grid:focus-within {
  outline: unset;
}

ch-grid-columnset {
  background-color: #d4d4d4;
}

ch-grid-column {
  padding-block: 4px;
  padding-inline: 4px;
}

ch-grid-column::part(bar) {
  width: 100%;
}

ch-grid-column::part(bar)::after {
  content: "";
  order: 3;
  margin-left: auto;
}

ch-grid-column::part(bar-resize) {
  width: 3px;
}

ch-grid-rowset-legend {
  background-color: lightgrey;
}

ch-grid-row {
  padding-block: 2px;
  border-block-end: 1px solid lightgrey;
}

ch-grid-row[highlighted] {
  background-color: #e8e8e9;
}

ch-grid-row[selected] {
  background-color: #cfdee6;
}

ch-grid-cell {
  padding-inline: 4px;
}

ch-grid-cell[selected] {
  background-color: #cfdee6;
  outline: 1px solid #0266a0;
  outline-offset: -1px;
}

ch-grid-cell::part(node-icon) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: center;
}

ch-grid-row:has(> ch-grid-rowset) > ch-grid-cell::part(node-icon) {
  background-image: url("../icons/folder.svg");
}

ch-grid-cell::part(node-icon) {
  background-image: url("../icons/file.svg");
}

ch-grid-rowset-legend::part(icon) {
  width: 16px;
  height: 16px;
  background-image: url("../icons/group.svg");
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: center;
}

ch-grid::part(settings-mask) {
  background-color: rgba(0, 0, 0, 0.2);
}

ch-grid-cell::part(drag-icon) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/drag.svg");
}

ch-grid-cell::part(actions-icon) {
  padding: 0px;
  border: 0px none transparent;
  background-color: transparent;
  box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: center;
  background-image: url("../icons/view-more.svg");
}

/* caret */
ch-grid-row > ch-grid-cell::part(caret),
ch-grid-rowset > ch-grid-rowset-legend::part(caret) {
  width: 16px;
  height: 16px;
  background-image: url("../icons/node_collapse.gif");
}

ch-grid-row:is([collapsed], [leaf="false"]:not(:has(> ch-grid-rowset))) > ch-grid-cell::part(caret),
ch-grid-rowset[collapsed] > ch-grid-rowset-legend::part(caret) {
  background-image: url("../icons/node_expand.gif");
}

ch-grid-actionbar {
  display: inline-block;
  margin-top: 10px;
}

ch-grid-action-refresh {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position: center;
  background-image: url("../icons/refresh.svg");
}

ch-grid-action-settings {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position: center;
  background-image: url("../icons/settings.svg");
}

ch-grid-column::part(bar-settings-button) {
  all: unset;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/settings.svg");
}

ch-grid-column::part(bar-sort-ascending) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/sort-asc.svg");
}

ch-grid-column::part(bar-sort-descending) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/sort-desc.svg");
}

/* grid settings window */
ch-grid::part(settings-window),
ch-grid-column::part(settings-window) {
  background: white;
  padding: 5px;
  border: solid 1px grey;
}

ch-grid::part(settings-header),
ch-grid-column::part(settings-header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

ch-grid::part(settings-caption),
ch-grid-column::part(settings-caption) {
  text-transform: uppercase;
}

ch-grid::part(settings-close),
ch-grid-column::part(settings-close) {
  background-position: center;
  margin-bottom: 0px;
  cursor: pointer;
}

/* indentation */
ch-grid {
  --indent: 16px;
}

.column-settings {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 100px;
}

ch-grid-row-actions[show-on-row-hover]::part(window) {
  margin-right: 19px;
}

*,
::after,
::before {
  box-sizing: border-box;
}

ch-test-flexible-layout {
  display: contents;
}

.flexible-layout::part(bar visible) {
  background-color: #e7e7e7;
}
.flexible-layout::part(inline__page-container) {
  background-color: #f2f2f2;
}
.flexible-layout::part(inline__tab-list) {
  background-color: #e8e8e9;
  inline-size: 48px;
  gap: 4px;
}
.flexible-layout::part(inline__button) {
  position: relative;
  block-size: 32px;
  inline-size: 48px;
}
.flexible-layout::part(inline__button)::before {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  -webkit-mask-size: 16px;
}
.flexible-layout::part(inline__button selected)::after {
  content: "";
  display: flex;
  position: absolute;
  inset-block-start: 4px;
  inset-inline-start: 1px;
  block-size: calc(100% - 8px);
  inline-size: 2px;
  background-color: currentColor;
}
.flexible-layout::part(inline__button inlineEnd selected)::after {
  inset-inline-start: unset;
  inset-inline-end: 1px;
}
.flexible-layout::part(inline__page-name) {
  display: block;
  padding-block: 8px;
  padding-inline: 16px;
}
.flexible-layout::part(close-button) {
  padding: 1px;
}
.flexible-layout::part(close-button):hover {
  background-color: color-mix(in srgb, currentColor 10%, transparent);
  border-radius: 4px;
}
.flexible-layout::part(close-button):focus-visible {
  outline: 1px solid currentColor;
}
.flexible-layout::part(inline__button):focus-visible {
  outline: 1px solid currentColor;
  outline-offset: -1px;
}
.flexible-layout::part(block__button) {
  padding-block: 6px;
  padding-inline: 16px 8px;
  gap: 8px;
  background-color: #ececec;
}
.flexible-layout::part(block__button):focus-visible {
  outline: 1px solid currentColor;
  outline-offset: -1px;
}
.flexible-layout::part(block__button selected) {
  background-color: #fff;
}
.flexible-layout::part(block__button selected blockEnd) {
  position: relative;
}
.flexible-layout::part(block__button selected blockEnd)::after {
  content: "";
  position: absolute;
  inset-block-start: 0;
  inset-inline: 0;
  block-size: 1px;
  background-color: currentColor;
  z-index: 1;
}
.flexible-layout::part(block__tab-list) {
  background-color: #f7f7f7;
}
.flexible-layout::part(block__page-container), .flexible-layout::part(inline__page-container) {
  overflow: auto;
}
.flexible-layout::part(drag-preview-element block__button) {
  padding-inline: 25px;
}
.flexible-layout::part(drag-preview--outside-tab-list) {
  box-shadow: 0 3px 4px 1px #00000020;
}

.ch-tree-view-item--success::part(action)::before {
  grid-area: first-img;
  content: "";
  width: 12px;
  height: 12px;
  margin-inline-end: 4px;
  background-color: #459660;
  border-radius: 50%;
}

.ch-tree-view-item--success::part(action) {
  grid-template: "first-img left-img text right-img"/max-content max-content 1fr max-content;
}

.tree-view-item--success::part(action)::before {
  grid-area: left-img;
  content: "";
  width: 10px;
  height: 10px;
  margin-inline-end: 4px;
  background-color: #459660;
  border-radius: 50%;
  z-index: 1;
}

.tree-view-item--custom-image::part(action)::before {
  grid-area: left-img;
  content: "";
  width: 14px;
  height: 14px;
  margin-inline-end: 4px;
  background-color: #455496;
  border-radius: 50%;
  z-index: 1;
}

.tree-view-item--folder::part(action)::before,
.tree-view-item--module::part(action)::before {
  grid-area: left-img;
  content: "";
  width: 14px;
  height: 14px;
  margin-inline-end: 4px;
  background-repeat: no-repeat;
}

.tree-view-item--folder::part(action)::before {
  background-image: url("assets/icons/folder.svg");
}

.tree-view-item--folder::part(action expanded)::before {
  background-image: url("assets/icons/folder-open.svg");
}

.tree-view-item--module::part(action)::before {
  background-image: url("assets/icons/module.svg");
}

.tree-view-item--module::part(action expanded)::before {
  background-image: url("assets/icons/module-open.svg");
}

.tree-view-item--pending-commit::part(action)::before {
  content: "";
  position: relative;
  z-index: 1;
  grid-area: left-img;
  width: 5px;
  height: 5px;
  align-self: end;
  margin-block-end: 3px;
  margin-inline-start: 1px;
  background-color: #2c3b92;
  border-radius: 50%;
}

.configuration {
  display: grid;
  grid-template-columns: repeat(5, max-content);
  grid-template-rows: min-content min-content min-content min-content;
  gap: 12px 24px;
}

.tree-buttons {
  display: grid;
  grid-auto-rows: max-content;
  row-gap: 8px;
}

.ch-tree-view-item--drag-enter {
  background-color: #eee;
  box-shadow: inset 0 0 1px 0px black;
}
.ch-tree-view-item--drag-enter[selected]::part(header) {
  background-color: #eee;
}

.ch-tree-view-not-dragging-item .tree-view-item:not([aria-selected])::part(header):hover {
  background-color: #e8e8e9;
}

.tree-view-item::part(header) {
  border: 1px solid transparent;
}
.tree-view-item[aria-selected]::part(header) {
  background-color: #cfdee6;
  border-color: #0266a0;
}
.tree-view-item:not([aria-selected])::part(header):hover {
  background-color: #e8e8e9;
}
.tree-view-item.ch-tree-view-item--editing::part(header) {
  background-color: rgba(207, 222, 230, 0.5);
  border-color: transparent;
}
.tree-view-item:not(.ch-tree-view-item--editing)::part(header):focus-visible {
  border-color: black;
  z-index: 1;
}

.ch-tree-view-drag-info {
  padding-inline: 6px;
  padding-block: 2px;
  background-color: #cfdee6;
  border: 1px solid #0266a0;
  border-radius: 10px;
  font-size: 8px;
}